import * as React from 'react';
import { FontIcon, ImageIcon } from '@fluentui/react/lib/Icon';
import { IImageProps } from '@fluentui/react/lib/Image';
import { ControlIcons } from 'owa-control-icons';
import { observer } from 'mobx-react-lite';

const styles = require('./AttachmentContextMenuPremiumItemButton.scss');
const classNames = require('classnames/bind').bind(styles);

export interface AttachmentContextMenuPremiumItemButtonProps {
    iconProps: IImageProps;
    itemText: string;
    shouldShowDiamond: boolean;
}

export default observer(function AttachmentContextMenuPremiumItemButton(
    props: AttachmentContextMenuPremiumItemButtonProps
) {
    return (
        <>
            <ImageIcon
                className={classNames('ms-ContextualMenu-icon', styles.menuIcon)}
                imageProps={props.iconProps}
            />
            <span className={classNames('ms-ContextualMenu-itemText', styles.menuText)}>
                {props.itemText}
            </span>
            {props.shouldShowDiamond && (
                <FontIcon
                    className={classNames(
                        'ms-ContextualMenu-icon',
                        styles.menuIcon,
                        styles.diamondIcon
                    )}
                    iconName={ControlIcons.Diamond}
                />
            )}
        </>
    );
});
